import React, { useState } from 'react';
import { connect } from 'react-redux';

import PropTypes from 'prop-types';

import { toggleModalWithTimer, toggleSpinner } from 'apps/auth/actions/appAction';
import { addExtras } from 'apps/auth/actions/extraAction';
import { DangerouslyHtml } from 'apps/auth/components/common/DangerouslyHtml/DangerouslyHtml';
import PopupButton from 'apps/auth/components/common/Popup/PopupButton';
import SimplePopup from 'apps/auth/components/common/Popup/SimplePopup';
import { AUTH_GA_CARD, AUTH_GA_CARDS } from 'apps/auth/constants/UrlConstants';
import { apiFetchData } from 'apps/auth/helpers/api';
import { requestsReissueCard } from 'apps/auth/services/GaCardsService';

const CancelOrReissueCardPopup = (props) => {
    const [showRepeatAgree, setShowRepeatAgree] = useState(false);

    const closeModal = () => {
        window.location.href = AUTH_GA_CARDS;
    };

    const replaceCardUrl = (cardId) => {
        props.toggleModalWithTimer(true, props.messageCardReissued, () => (window.location.href = AUTH_GA_CARD + cardId));
    };

    const onButtonClick = () => {
        props.popupRef?.current?.close();
        if (props.isLibre) {
            requestsReissueCard(props.card, props.toggleSpinner, props.addExtras, null, replaceCardUrl);
        } else {
            cancelCard();
        }
    };
    const cancelCard = () => {
        props.toggleSpinner(true);
        apiFetchData(`${AUTH_GA_CARD}${props.card.id}/remove`)
            .then(() => {
                props.toggleSpinner(false).then(() => props.toggleModalWithTimer(true, props.messageCardCancelled, closeModal));
            })
            .catch(() => {
                props.toggleSpinner(false);
            });
    };

    return showRepeatAgree || props.agree ? (
        <SimplePopup
            text={<DangerouslyHtml dangerouslyHtml={props.isLibre ? props.cancelAndReissueCardInfo : props.cancelCardInfo} />}
            popupRef={props.popupRef}
        >
            <PopupButton
                isAlertButton
                iconName="scissors"
                text={props.isLibre ? props.cancelAndReissueCardButton : props.cancelCardButton}
                onClick={() => {
                    onButtonClick();
                }}
            />
        </SimplePopup>
    ) : (
        <SimplePopup withoutBorder popupRef={props.popupRef}>
            <PopupButton
                iconName="scissors"
                text={props.isLibre ? props.cancelAndReissueCard : props.cancelCard}
                onClick={(e) => {
                    e.preventDefault();
                    setShowRepeatAgree(true);
                }}
            />
        </SimplePopup>
    );
};
const mapStateToProps = (state) => ({
    cancelCard: state.messages.pageMessages.cancelCard,
    cancelCardInfo: state.messages.pageMessages.cancelCardInfo,
    cancelCardButton: state.messages.pageMessages.cancelCardButton,
    messageCardCancelled: state.messages.pageMessages.messageCardCancelled,
    messageCardReissued: state.messages.pageMessages.messageCardReissued,
    cancelAndReissueCard: state.messages.pageMessages.cancelAndReissueCard,
    cancelAndReissueCardInfo: state.messages.pageMessages.cancelAndReissueCardInfo,
    cancelAndReissueCardButton: state.messages.pageMessages.cancelAndReissueCardButton,
    card: state.extra.card,
    isLibre: state.extra.isLibre,
});

CancelOrReissueCardPopup.propTypes = {
    popupRef: PropTypes.shape({ current: PropTypes.object }).isRequired,
};
export default connect(mapStateToProps, { toggleSpinner, toggleModalWithTimer, addExtras })(CancelOrReissueCardPopup);
